import { TUpdateAction } from "@fl/shared/src/types/actions";
import { GerenciadorPaginasItens } from "@fl/shared/src/types/menus";
import { UpdatePaginasMenu } from "@fl/shared/src/types/models/suporte_fl/paginas_menus";
import { useEffect, useState } from "react";
import {
  onCheckMenus,
  onCollapseMenus,
  organizeMenus,
} from "../../../utils/menusFuncs";
import SortFunctions from "../../../utils/sortArrays";
import MenuToolManagerItem from "./item";
import "./styles.css";

interface IProps {
  menus: UpdatePaginasMenu[];
  setMenus: React.Dispatch<React.SetStateAction<UpdatePaginasMenu[]>>;
  onUpdate: (item: GerenciadorPaginasItens, action: TUpdateAction) => void;
}

const MenuToolManager: React.FC<IProps> = ({ menus, setMenus, onUpdate }) => {
  const [pages, setPages] = useState<GerenciadorPaginasItens[]>([]);
  const [elementsMenus, setElementsMenus] = useState<JSX.Element[]>([]);

  useEffect(() => {
    if (menus.length > 0) {
      const initialPages: GerenciadorPaginasItens[] = [];
      const finalPages = [
        ...organizeMenus(
          menus,
          menus.filter((item) => item.id_pagina_menu_pai === null),
          initialPages,
          0
        ),
      ];
      setPages(finalPages);
    }
  }, [menus]);

  useEffect(() => {
    const elements = pages
      .sort((a, b) => new SortFunctions(a, b).sortMenus())
      .map((item) => {
        return renderItems(item, false);
      });
    setElementsMenus(elements);
  }, [pages]);

  const renderItems = (item: GerenciadorPaginasItens, children: boolean) => {
    var subelements: JSX.Element[] = [];
    if (item.children) {
      subelements = item.children.map((item) => {
        return renderItems(item, true);
      });
    }

    return (
      <MenuToolManagerItem
        key={`root_${item.pagina}`}
        item={item}
        subelements={subelements}
        children={children}
        onCheck={(item) => {
          setMenus(onCheckMenus(item, menus));
        }}
        onCollapse={(item) => {
          setMenus(onCollapseMenus(item, menus));
        }}
        onUpdate={onUpdate}
        onUpdateDrag={onUpdateDrag}
        showAction={true}
        showCollapse={true}
        showOrder={true}
      />
    );
  };

  const onUpdateDrag = (
    draggedItemId: number,
    targetItemId: number | null,
    position: number
  ) => {
    const draggedItem: UpdatePaginasMenu | undefined = menus.find(
      (item) => item.id_pagina_menu === draggedItemId
    );
    const targetItem: UpdatePaginasMenu | undefined = menus.find(
      (item) => item.id_pagina_menu === targetItemId
    );

    const rerenderMenus: UpdatePaginasMenu[] = [...menus];
    let selectedMenus: UpdatePaginasMenu[] = [];

    if (draggedItem && targetItem) {
      if (position === 1) {
        // INSIDE
        const draggedItemIndex = rerenderMenus.findIndex(
          (item) => item.id_pagina_menu === draggedItemId
        );
        draggedItem.id_pagina_menu_pai = targetItem.id_pagina_menu; // Atualiza o pai
        rerenderMenus[draggedItemIndex] = { ...draggedItem };

        // Ajusta as ordens dos filhos do novo pai (se necessário)
        selectedMenus = rerenderMenus.filter(
          (item) => item.id_pagina_menu_pai === targetItem.id_pagina_menu
        );
      } else {
        // TOP ou BOTTOM
        if (draggedItem.id_pagina_menu_pai === targetItem.id_pagina_menu_pai) {
          // Mesmo pai
          selectedMenus = [
            ...rerenderMenus.filter(
              (item) =>
                item.id_pagina_menu_pai === draggedItem.id_pagina_menu_pai
            ),
          ];
        } else {
          // Pai diferente
          const draggedItemIndex = rerenderMenus.findIndex(
            (item) => item.id_pagina_menu === draggedItemId
          );
          draggedItem.id_pagina_menu_pai = targetItem.id_pagina_menu_pai; // Atualiza o pai
          rerenderMenus[draggedItemIndex] = { ...draggedItem };

          selectedMenus = [
            ...rerenderMenus.filter(
              (item) =>
                item.id_pagina_menu_pai === targetItem.id_pagina_menu_pai
            ),
          ];
        }
      }

      const draggedItemIndex = selectedMenus.findIndex(
        (item) => item.id_pagina_menu === draggedItemId
      );

      if (draggedItemIndex > -1) {
        // Atualiza a ordem com base na posição
        selectedMenus[draggedItemIndex].ordem =
          position === 0 // TOP
            ? targetItem.ordem - 0.5
            : position === 2 // BOTTOM
              ? targetItem.ordem + 0.5
              : selectedMenus[draggedItemIndex].ordem; // INSIDE mantém a ordem

        // Reordena e ajusta os índices
        selectedMenus
          .sort((a, b) => new SortFunctions(a.ordem, b.ordem).sortNumberAsc())
          .map((item, index) => {
            const idx = menus.findIndex(
              (i) => i.id_pagina_menu === item.id_pagina_menu
            );
            rerenderMenus[idx].ordem = index;
            rerenderMenus[idx].edited = true;
          });

        // Atualiza o estado com a nova lista ordenada
        setMenus(
          rerenderMenus.sort((a, b) =>
            new SortFunctions(a.ordem, b.ordem).sortNumberAsc()
          )
        );
      }
    }
  };

  return <div>{elementsMenus.length > 0 && <ul>{elementsMenus}</ul>}</div>;
};

export default MenuToolManager;
